<template>
  <div class="element-box">
    <div class="row">
      <div class="col-12">
        <h5 class="form-header mb-4">
          Fahrtkosten informationen - {{ travelExpenses.year }},
          {{ $t(`calendar.months_number_key.${travelExpenses.month}`) }}
        </h5>
      </div>
    </div>

    <div class="row align-items-end">
      <div class="col-lg-6 col-sm-12">
        <p style="font-size: 18px; margin-bottom: 6px;"><strong>Mitarbeiter:</strong>
          {{ travelExpenses?.user?.firstName }} {{ travelExpenses?.user?.lastName }}
        </p>
        <p style="font-size: 15px; margin-bottom: 6px;"><strong>Gesamte Kilometer:</strong>
          {{ travelExpenses?.distance }} km
        </p>
        <p style="font-size: 15px; margin-bottom: 6px;"><strong>Kilometerpauschale:</strong>
          {{ travelExpenses?.price }} €/km
        </p>
        <p style="font-size: 15px; margin-bottom: 15px;"><strong>Auszahlungsbetrag:</strong>
          {{ travelExpenses?.total }} €
        </p>

        <h6 class="mb-4">
          Status:
          <span v-if="travelExpenses?.status === 'draft'" class="status-pill yellow p-2 ms-1"
                data-bs-toggle="tooltip"></span>
          <span v-if="travelExpenses?.status === 'modification'" class="status-pill red p-2 ms-1"
                data-bs-toggle="tooltip"></span>
          <span v-if="travelExpenses?.status === 'pending'" class="status-pill yellow p-2 ms-1"
                data-bs-toggle="tooltip"></span>
          <span v-if="travelExpenses?.status === 'approved_by_coordinator'" class="status-pill p-2 ms-1"
                style="background-color: mediumseagreen" data-bs-toggle="tooltip"></span>
          <span v-if="travelExpenses?.status === 'approved'" class="status-pill green p-2 ms-1"
                data-bs-toggle="tooltip"></span>
          {{ travelExpenses?.statusTranslated }}
        </h6>
      </div>

      <div class="col-lg-6">

        <!-- Coordinator buttons -->
        <div v-if="isHr === false && travelExpenses?.status === 'pending'">
          <div class="d-flex justify-content-end mt-1">
            <div id="portalDocumentExport">
              <a target="_blank"
                 class="btn portal_pdf_export"
                 @click="downloadFile(`/travel-expenses/coordinator/excel-export/${travelExpenses.id}`,
            undefined, undefined, false)">
                <img src="../../../../../assets/img/excel_icon.jpg" alt=""/>
                <p> {{ $t('general.excel_export') }}</p>
              </a>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-5">
            <div class="me-2">
              <CreateButton
                  :label="$t('general.approve')"
                  variant="primary"
                  @click.prevent="approval('approved_by_coordinator')">
              </CreateButton>
            </div>

            <CreateButton
                :label="$t('general.decline')"
                variant="danger"
                @click.prevent="decline">
            </CreateButton>
          </div>
        </div>


        <!-- HR buttons -->
        <div v-else-if="
        (isHrAndCoordinator === true && travelExpenses?.status === 'pending') ||
        (isHr === true && travelExpenses?.status === 'approved_by_coordinator') ||
        (isHr === true && travelExpenses?.status === 'pending')">
          <div class="d-flex justify-content-end mt-1">
            <div id="portalDocumentExport">
              <a target="_blank"
                 class="btn portal_pdf_export"
                 @click="downloadFile(`/travel-expenses/coordinator/excel-export/${travelExpenses.id}`,
            undefined, undefined, false)">
                <img src="../../../../../assets/img/excel_icon.jpg" alt=""/>
                <p> {{ $t('general.excel_export') }}</p>
              </a>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-5">
            <div class="me-2">
              <CreateButton
                  :label="$t('general.button.approve')"
                  variant="primary"
                  @click.prevent="approval('approved')">
              </CreateButton>
            </div>

            <CreateButton
                :label="$t('general.decline')"
                variant="danger"
                @click.prevent="decline">
            </CreateButton>
          </div>
        </div>

        <div v-else class="d-flex justify-content-end h-100">
              <a target="_blank"
                 class="btn portal_pdf_export"
                 @click="downloadFile(`/travel-expenses/coordinator/excel-export/${travelExpenses.id}`,
            undefined, undefined, false)">
                <img src="../../../../../assets/img/excel_icon.jpg" alt="" width="50" height="63"/>
                <p class="mt-2 mb-0">{{ $t('general.excel_export') }}</p>
              </a>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import CreateButton from '@/components/CreateButton.vue';
import {CloseToast} from '@/components/VueToast';
import {downloadFile} from '@/shared/functions';
import {defineEmits, defineProps, toRefs} from 'vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
const emit = defineEmits(['approveTravelExpenses', 'declineTravelExpenses']);

const props = defineProps({
  travelExpenses: {
    type: Object,
    required: false,
  },
  isHr: {
    type: Boolean,
    required: true,
  },
  isHrAndCoordinator:{
    type: Boolean,
    required: true,
  }
});

const {travelExpenses, isHr} = toRefs(props);

function approval(approvalStatus) {
  CloseToast();
  emit('approveTravelExpenses', approvalStatus);
}

function decline() {
  CloseToast();
  emit('declineTravelExpenses');
}

</script>

<style scoped>

</style>